const breakPoint = 768;
let mySwiper;
let mySwiperBool;

window.addEventListener(
  "load",
  () => {
    if (breakPoint < window.innerWidth) {
      mySwiperBool = false;
    } else {
      createSwiper();
      mySwiperBool = true;
    }
  },
  false
);

window.addEventListener(
  "resize",
  () => {
    if (breakPoint < window.innerWidth && mySwiperBool) {
      mySwiper.destroy(false, true);
      mySwiperBool = false;
    } else if (breakPoint >= window.innerWidth && !mySwiperBool) {
      createSwiper();

      mySwiperBool = true;
    }
  },
  false
);

const createSwiper = function () {
  mySwiper = new Swiper(".brandSwiper", {
    slidesPerView: 1.5, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
    clickable: true, // クリック操作
    loop: false,
    spaceBetween: 20,
    breakpoints: {
      // ブレークポイント

      767: { slidesPerView: 2.5 },

      1024: { slidesPerView: 3 },
    },

    pagination: {
      // el: ".swiper-pagination",
      // dynamicBullets: true,
    },
  });
};

const resizeSwiper = function () {
  let width = window.innerWidth;

  // 画面幅が768以下(スマホ)の時
  let heroSwiper;
  if (width <= 768) {
    heroSwiper = new Swiper(".heroSwiper", {
      slidesPerView: 1, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
      slidesPerView: 1.3,
      loop: true,
      speed: 4000,
      spaceBetween: 20,
      allowTouchMove: true, // スマホのスワイプ
      clickable: true, // クリック操作
      autoplay: {
        delay: 100,
        disableOnInteraction: false, // ユーザのアクションがあった時自動再生をdisable
      },
    });
  } else {
    // 画面幅が768以上(pcの時)
    heroSwiper = new Swiper(".heroSwiper", {
      slidesPerView: 1.3,
      loopedSlides: 2,
      loop: true,
      speed: 12000, // ループの時間
      spaceBetween: 20,
      allowTouchMove: true, // スマホのスワイプ
      clickable: true, // クリック操作
      autoplay: {
        delay: 0, // 途切れなくループ
        disableOnInteraction: false, // ユーザのアクションがあった時自動再生をdisable
      },
    });
  }
};

window.addEventListener("load", function () {
  resizeSwiper();
});

const scrollTop = function () {
  const scrollTopBtn = document.querySelector(".js-scrollTop");
  scrollTopBtn.addEventListener("click", function () {
    window.scroll({ top: 0, behavior: "smooth" });
  });
};

scrollTop();

const accTtls = Array.from(document.querySelectorAll(".accordion_ttl"));
accTtls.forEach((item) => {
  item.addEventListener("click", function () {
    this.classList.toggle("active");
    const accCnt = this.nextElementSibling;
    if (accCnt.style.maxHeight) {
      accCnt.style.maxHeight = null;
    } else {
      accCnt.style.maxHeight = accCnt.scrollHeight + "px";
    }
  });
});
